import { useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { dashboardSections } from "../../../consts";
import { csvUtil } from "../../../utils";

import OverviewSection from "./sections/OverviewSection";
import FirmwareSection from "./sections/FirmwareSection";
import DiagnosticSection from "./sections/DiagnosticSection";
import SettingsSection from "./sections/SettingsSection";
import BatteryHealthSection from "./sections/BatteryHealthSection";

import { GridWrapper } from "./styled";
import DefaultSection from "./sections/DefaultSection";

const DashboardSections = ({ activePage }) => {
  const chartFilters = useSelector((store) => store.rum.chartFilters);
  const loadingCharts = useSelector((store) => store.rum.loadingCharts);
  const errorCharts = useSelector((store) => store.rum.errorCharts);

  const getChartFilter = useCallback(
    (chartId) => {
      return chartFilters?.find((chart) => chart.id === chartId)?.filter;
    },
    [chartFilters]
  );

  const getIsLoading = useCallback(
    (chartId) => {
      return loadingCharts.includes(chartId);
    },
    [loadingCharts]
  );

  const getIsError = useCallback(
    (chartId) => {
      return errorCharts.includes(chartId);
    },
    [errorCharts]
  );

  const downloadCSV = (data, filename) => {
    const statsCsv = csvUtil.createCSVFile(data);
    csvUtil.downloadCSVFile(statsCsv, filename);
  };

  return (
    <GridWrapper>
      {!activePage && (
        <DefaultSection
          getChartFilter={getChartFilter}
          getIsLoading={getIsLoading}
          getIsError={getIsError}
          downloadCSV={downloadCSV}
        />
      )}

      {activePage === dashboardSections.OVERVIEW && (
        <OverviewSection
          getChartFilter={getChartFilter}
          getIsLoading={getIsLoading}
          getIsError={getIsError}
        />
      )}
      {activePage === dashboardSections.FIRMWARE && (
        <FirmwareSection
          getChartFilter={getChartFilter}
          getIsLoading={getIsLoading}
          getIsError={getIsError}
          downloadCSV={downloadCSV}
        />
      )}
      {activePage === dashboardSections.DIAGNOSTIC && (
        <DiagnosticSection
          getChartFilter={getChartFilter}
          getIsLoading={getIsLoading}
          getIsError={getIsError}
          downloadCSV={downloadCSV}
        />
      )}
      {activePage === dashboardSections.SETTINGS && (
        <SettingsSection
          getChartFilter={getChartFilter}
          getIsLoading={getIsLoading}
          getIsError={getIsError}
        />
      )}
      {activePage === dashboardSections.BATTERY_HEALTH && (
        <BatteryHealthSection
          getChartFilter={getChartFilter}
          getIsLoading={getIsLoading}
          getIsError={getIsError}
        />
      )}
    </GridWrapper>
  );
};

DashboardSections.propTypes = {
  activePage: PropTypes.string
};

export default DashboardSections;
